<template>
  <div>
    <!-- begin breadcrumb -->
    <ol class="breadcrumb pull-right">
      <li class="breadcrumb-item active">
        <a href="javascript:;">快递公司</a>
      </li>
    </ol>
    <!-- end breadcrumb -->
    <!-- begin page-header -->
    <h1 class="page-header">
      快递公司
      <small>快递公司管理...</small>
    </h1>
    <!-- end page-header -->
    <panel title="快递公司列表" :noButton="true">
      <div slot="heading-btn">
        <button
          type="button"
          class="btn btn-theme btn-sm"
          style="margin-right: 5px"
          @click="fn_add_expresscorp"
        >增加快递公司</button>
      </div>
      <Table border size="small" :columns="columns" :data="data">
        <template slot-scope="{ row }" slot="status">
          <strong v-if="row.status==0">有效</strong>
          <strong v-else style="color:red">无效</strong>
        </template>
        <template slot-scope="{ row, index }" slot="action">
          <button
            type="button"
            class="btn btn-theme btn-sm"
            style="margin-right: 5px"
            @click="fn_edit_expresscorp(row,index)"
          >修改快递公司</button>

          <Poptip
            v-if="row.status == 0"
            transfer
            confirm
            title="是否要作废此快递公司?"
            @on-ok="fn_unvalid(row,index)"
            ok-text="确认"
            cancel-text="取消"
          >
            <button type="button" class="btn btn-danger btn-sm">作废</button>
          </Poptip>
          <Poptip
            v-else
            transfer
            confirm
            title="是否要恢复此快递公司?"
            @on-ok="fn_restore(row,index)"
            ok-text="确认"
            cancel-text="取消"
          >
            <button type="button" class="btn btn-theme btn-sm">恢复</button>
          </Poptip>
        </template>
      </Table>
      <Page
        style="margin-top:10px"
        :total="totalRows"
        :current="currentPage"
        :page-size="pageNum"
        show-total
        show-elevator
        @on-change="fn_switchPage"
      />
    </panel>
    <Row>
      <Col span="12">
        <Card :bordered="false" class="m-t-10">
          <p slot="title">快递鸟查询物流API配置</p>
          <Form :labelWidth="120">
            <FormItem label="商户ID">
              <Input v-model="kuaidi.EBusinessID" />
            </FormItem>
            <FormItem label="商户KEY">
              <Input v-model="kuaidi.AppKey" />
            </FormItem>
            <FormItem label="请求地址">
              <Input v-model="kuaidi.ReqURL" />
            </FormItem>
            <FormItem>
              <button type="button" class="btn btn-theme btn-sm" @click="fn_save_kuaidiniao">保存配置</button>
            </FormItem>
          </Form>
        </Card>
      </Col>
    </Row>

    <Drawer title="快递公司" v-model="v_edit_expresscorp" width="720" :mask-closable="true">
      <Form :model="formData" ref="formData" :rules="rules" :labelWidth="120">
        <FormItem label="快递代码" label-position="top" prop="corpcode">
          <Input v-model="formData.corpcode" placeholder="快递代码" />
        </FormItem>
        <FormItem label="快递名称" label-position="top" prop="corpname">
          <Input v-model="formData.corpname" placeholder="快递名称" />
        </FormItem>
        <FormItem label="描述" label-position="top" prop="description">
          <Input type="textarea" v-model="formData.description" placeholder="描述" />
        </FormItem>
        <FormItem label>
          <span style="color:red">系统使用快递鸟的API查询接口,为了保证接口可用，请保持代码与快递鸟一致</span>
        </FormItem>
      </Form>
      <div class="demo-drawer-footer">
        <button
          type="button"
          class="btn btn-default"
          style="margin-right: 8px"
          @click="v_edit_expresscorp = false"
        >关闭</button>
        <button type="button" class="btn btn-theme" @click="fn_store_data">保存</button>
      </div>
    </Drawer>
  </div>
</template>
<script>
import {
  getExpressCorpList,
  storeExpressCorpData,
  unvalidExpressCorp,
  restoreExpressCorp,
  getKuaidiSet,
  setKuaidiSet
} from "@/api/config";
export default {
  data() {
    return {
      columns: [
        {
          title: "快递公司代码",
          key: "corpcode",
          width: 150
        },
        {
          title: "名称",
          key: "corpname",
          width: 200
        },
        {
          title: "描述",
          key: "description"
        },
        {
          title: "状态",
          slot: "status",
          width: 120
        },
        {
          title: "操作",
          slot: "action",
          width: 280,
          align: "left"
        }
      ],
      kuaidi: {
        EBusinessID: "",
        AppKey: "",
        ReqURL: ""
      },
      data: [],
      rules: {
        corpcode: [
          {
            required: true,
            message: "代码必填",
            trigger: "blur"
          }
        ],
        corpname: [
          {
            required: true,
            message: "名称必填",
            trigger: "blur"
          }
        ]
      },
      totalRows: 0,
      pageNum: 10,
      currentPage: 1,
      formData: {
        id: 0,
        corpcode: "",
        corpname: "",
        description: "",
        printtemplate: "",
        userid: 0,
        status: 0
      },
      v_edit_expresscorp: false
    };
  },
  mounted() {
    let filterCond = {
      page: 1,
      pageNum: this.pageNum
    };
    this.fn_load_data(filterCond);
  },
  methods: {
    fn_load_data(filterCond) {
      getExpressCorpList(filterCond)
        .then(res => {
          this.data = res.data.data;
          this.totalRows = res.data.total;
        })
        .catch(error => {
          this.$Message.error(error);
        });
      getKuaidiSet()
        .then(res => {
          this.kuaidi = res.data;
        })
        .catch(error => {
          this.$Message.error(error);
        });
    },
    fn_switchPage(page) {
      this.currentPage = page;
      let filterCond = {
        page: page,
        pageNum: this.pageNum
      };
      this.fn_load_data(filterCond);
    },
    fn_add_expresscorp() {
      this.formData = {
        id: 0,
        corpcode: "",
        corpname: "",
        description: "",
        printtemplate: "",
        userid: 0,
        status: 0
      };
      this.v_edit_expresscorp = true;
    },
    fn_store_data() {
      this.$refs.formData.validate(valid => {
        console.log(valid);
        if (valid) {
          storeExpressCorpData(this.formData)
            .then(res => {
              if (res.data.code == 200) {
                if (this.formData.id == 0) {
                  this.data.push(res.data.data);
                }
                this.$Notice.success(res.data);
                this.v_edit_expresscorp = false;
              } else {
                this.$Notice.error(res.data);
              }
            })
            .catch(error => {
              this.$Message.error(error);
            });
        }
      });
    },
    fn_edit_expresscorp(row, index) {
      this.formData = row;
      this.v_edit_expresscorp = true;
    },
    fn_unvalid(row, index) {
      unvalidExpressCorp(row.id)
        .then(res => {
          if (res.data.code == 200) {
            row.status = -1;
          }
        })
        .catch(error => {
          this.$Message.error(error);
        });
    },
    fn_restore(row, index) {
      restoreExpressCorp(row.id)
        .then(res => {
          if (res.data.code == 200) {
            row.status = 0;
          }
        })
        .catch(error => {
          this.$Message.error(error);
        });
    },
    fn_save_kuaidiniao() {
      setKuaidiSet(this.kuaidi)
        .then(res => {
          if (res.data.code == 200) {
            this.$Notice.success(res.data);
          } else {
            this.$Notice.error(res.data);
          }
        })
        .catch(error => {
          this.$Message.error(error);
        });
    }
  }
};
</script>